import React from 'react';
import { AvatarElement, Loader } from './elements';

type Ava72Props = {
  readonly isLoading?: boolean;
  readonly className?: string;
  readonly onClick?: () => void;
  readonly image?: string;
};

export default function Ava72({
  isLoading,
  className,
  onClick,
  image,
}: Ava72Props) {
  if (isLoading) {
    return (
      <AvatarElement className={className} onClick={onClick}>
        <Loader />
      </AvatarElement>
    );
  }

  return (
    <AvatarElement className={className} onClick={onClick} $image={image} />
  );
}
